/**
 * PageContainer - Shared Layout Component
 * 
 * Provides consistent page wrapper with max-width, padding, and responsive behavior.
 * Used across all pages for consistent layout.
 * 
 * Design System: Layout Pattern - Universal Page Structure
 */

import React from 'react';

const PageContainer = ({
  children,
  maxWidth = '7xl', // 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '7xl' | 'full'
  padding = true, // true | false | 'mobile-only' | 'desktop-only'
  className = ''
}) => {
  const maxWidthClass = maxWidth === 'full' ? 'w-full' : `max-w-${maxWidth}`;
  
  let paddingClass = '';
  if (padding === true) {
    paddingClass = 'px-4 sm:px-6 lg:px-8';
  } else if (padding === 'mobile-only') {
    paddingClass = 'px-4 sm:px-0';
  } else if (padding === 'desktop-only') {
    paddingClass = 'px-0 sm:px-6 lg:px-8';
  }

  return (
    <div className={`mx-auto ${maxWidthClass} ${paddingClass} ${className}`}>
      {children}
    </div>
  );
};

export default PageContainer;
